
let _instance;

const _addJSON = function (id, json) {
    this._json = this._json || {};
    this._json[id] = json;

    return json;
}

const _setJSONNotLoaded = function (id) {
    this._json = this._json || {};
    if (typeof this._json[id] !== 'undefined') return this._json[id];
    this._json[id] = null;
}

const _getJSON = function (id) {
    if (!this._json) return undefined;
    return this._json[id];
}

const _clearJSON = function (id) {
    const json = this._json[id];
    delete this._json[id];
    return json;
}

const _createStorage = () => {
    const stg = {};

    stg.addJSON = _addJSON.bind(stg);
    stg.setJSONNotLoaded = _setJSONNotLoaded.bind(stg);
    stg.getJSON = _getJSON.bind(stg);
    stg.clearJSON = _clearJSON.bind(stg);

    return stg;
}

module.exports.instance = () => {
    if (_instance) return _instance;
    _instance = _createStorage();
    return _instance;
}

module.exports.destroy = () => {
    const instance = _instance;
    _instance = undefined;
    return instance;
}

module.exports.getIsolatedInstance = () => {
    return _createStorage();
}




// WEBPACK FOOTER //
// ./js/viscom/viscomjs/load/JSONStorage.js